import { Component, OnInit, OnDestroy, ViewChild, Inject, HostListener } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { DatePipe } from '@angular/common';

import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';
import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';
import { ModalDirective } from 'ngx-bootstrap/modal';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';

import { TransferRequest } from '../../../common/model/TransferRequest';
import { ExcelUtility } from '../../../common/util/ExcelUtility';
import { StoreFacade } from '../../../common/facade/StoreFacade';
import { TransferRequestExcelDto } from '../../../common/model/dto/TransferRequestExcelDto';
import { TransferRequestDto } from '../../../common/model/dto/TransferRequestDto';
import { TransferRequestFacade } from '../../../common/facade/TransferRequestFacade';
import { CatalogDetFacade } from '../../../common/facade/CatalogDetFacade';
import { Permissions } from '../../../common/model/dictionary/Permissions';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';
import { Organization } from '../../../common/model/Organization';
import { Store } from '../../../common/model/Store';
import { LoggerLayout } from '../../../common/model/LoggerLayout';
import { LoggerLayoutsFacade } from '../../../common/facade/LoggerLayoutsFacade';
import { TransferRequestInfo } from '../../../common/model/dictionary/TransferRequestInfo';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { DeactivationReason } from '../../../common/model/dictionary/DeactivationReason';
import { HasPendingChanges } from '../../../common/util/pending-changes.guard';
// Feature 46570 - Carga de Traspasos de ROi (flujo nuevo asíncrono)
import { TransferRequestBulkFacade } from '../../../common/facade/TransferRequestBulkFacade';
import { TransferBulkSignalRService } from '../../../common/service/TransferBulkSignalRService';
import {
  TransferRequestBulkUploadDto,
  TransferRequestBulkRowDto,
  TransferRequestBulkJobDto
} from '../../../common/model/dto/TransferRequestBulkDto';
import { Subscription } from 'rxjs';

// for excel import
type AOA = any[][];
declare const ResizeObserver: any;

@Component({
  selector: 'app-transfer-corporate',
  templateUrl: './transfer-corporate.component.html',
  styleUrls: ['./transfer-corporate.component.css']
})
export class TransferCorporateComponent implements OnInit, OnDestroy, HasPendingChanges {

  @ViewChild('table') table!: DatatableComponent;
  private _resizeObserver: any;

  public res = res;
  titleCorporateTransfer = res.CorporateTransfer;
  lblDownloadReport = res.DownloadReport;
  lblRequestTransfer = res.RequestTransfer;
  lblDownloadLayout = res.DownloadLayout;
  lblOriginStore = res.OriginStore;
  lblDestinationStore = res.DestinationStore;
  lblSelectAnOption = res.SelectAnOption;
  lblSearch = res.Search;
  lblTransferReference = res.TransferReference;
  lblShipment = res.Shipment;
  lblEntry = res.Entry;
  lblCancel = res.Cancel;
  lblRequestNewTransfer = res.RequestNewTransfer;
  lblWeek = res.Week;
  lblReference = res.ReferenceRequest;
  lblYear = res.Year;
  lblStartDate = res.StartDate;
  lblEndDate = res.EndDate;
  lblUploadTransferFile = res.UploadTransferFile;
  lblSelectAFile = res.SelectAFile;
  lblChoose = res.Choose;
  lblSave = res.Save;
  lblClose = res.Close;
  lblContinueSaving = res.ContinueSaving;
  lblRejected = res.Rejected;
  lblSent = res.Sent;
  lblRequested = res.Requested;
  lblDeadline = res.Deadline;
  lblRequestDate = res.RequestDate;
  lblReceived = res.Received;
  lblSector = res.Sector;
  lblOrganization = res.Organization;
  errorSmallerThan = res.SmallerDateThan;
  errorGreaterThan = res.GreaterDateThan;
  titleNotice = res.Notice;

  isSpanish = true;
  language = 0;
  fileNameModal = '';

  messagesTable: any = {
    emptyMessage: '',
    totalMessage: ''
  };

  loading = false;
  messageLoader = '';
  // alert
  alertsFileExcel: any[] = [];
  generalAlerts: any[] = [];
  onlySizesAlerts = [];
  // table
  rows: TransferRequest[] = [];
  private _filteredData: TransferRequest[] = [];
  // filters
  storeOriginId = -1;
  storesOrigin: Store[] = [];
  storeDestinyId = -1;
  storesDestiny: Store[] = [];
  sectorId = -1;
  sectors = [];
  organizationId = '-1';
  lstOrganization: Organization[] = [];
  availableOrganizations: Organization[] = [];
  selectedOrganizations: Organization[] = [];
  weeks: any[] = [];
  week = -1;
  reference = '';
  // modal
  @ViewChild('modal') public modal!: ModalDirective;
  txtWeek = -1;
  listWeek: number[] = [];
  txtReference = '';
  txtYear = new Date().getFullYear();
  txtDate = new Date();
  txtMinDate = new Date();
  txtMaxDate = this.getNowUTC();
  txtStartDate = new Date();
  txtEndDate = new Date();
  txtSearch = '';
  public txtDateAdd = this.getNowUTC();

  public txtMinDateResumen = new Date(this.getNowUTC().getFullYear() - 1,
    this.getNowUTC().getMonth(),
    1,
    this.getNowUTC().getHours(),
    this.getNowUTC().getMinutes(),
    this.getNowUTC().getSeconds(),
    this.getNowUTC().getMilliseconds());
  public txtMaxDateResumen = this.getNowUTC();
  public txtMinDateAdd = new Date(this.getNowUTC().getFullYear() - 1,
    this.getNowUTC().getMonth(),
    1,
    this.getNowUTC().getHours(),
    this.getNowUTC().getMinutes(),
    this.getNowUTC().getSeconds(),
    this.getNowUTC().getMilliseconds());
  public txtMaxDateAdd = this.getNowUTC();
  txtStartDateResumen = new Date();
  txtEndDateResumen = new Date();
  txtOrganization = -1;
  endDateResumen = new Date();
  startDateResumen = new Date();
  // import excel
  excelData: AOA = [[], []];
  wopts: XLSX.WritingOptions = { bookType: 'xlsx', type: 'array' };
  fileName = 'SheetJS.xlsx';
  excelRows: TransferRequestExcelDto[] = [];
  validatedData!: TransferRequestDto;
  // permissions
  hideStores = false;
  today = new Date();
  @ViewChild('warningModal') public warningModal!: ModalDirective;
  validateMessage = '';

  // permissions
  permissionsList: any[] = [];
  visibleAdd = false;
  visibleEdit = false;

  // Feature 46570 - Carga masiva (flujo nuevo)
  @ViewChild('bulkLogsModal') public bulkLogsModal!: ModalDirective;
  bulkJobs: TransferRequestBulkJobDto[] = [];
  bulkSelectedGuid = '';           // guid del job cuya descarga de no procesados esta en curso
  bulkCanSeeAll = false;           // visibilidad total por permiso
  bulkLoadingLogs = false;         // carga de la LISTA de jobs en curso (spinner de "Mis cargas")
  bulkLoadingFailed = false;        // descarga de "no procesados" en curso (guard anti doble-clic)
  private _bulkSignalRSub?: Subscription;
  private _bulkJobsPolling?: any;        // auto-refresh de "Mis cargas" mientras haya jobs activos
  private readonly _bulkPollMs = 4000;   // intervalo de refresco de la lista de cargas
  strOrganizationSelected!: string;
  tenantId!: number;
  isDisabledSaveTransfer = false;
  searchTransfer = false;
  batchProgress: { current: number; total: number; failed: string[] } | null = null;
  _failedBatches: Map<string, TransferRequestDto> = new Map();
  batchResultMessage = '';
  private _skipDuplicateCheck = false;
  private _skipMultiRowCheck = false;
  private _skipMaxVersionCheck = false;
  maxVersionBlockedCodes: string[] = [];
  @ViewChild('duplicateModal') public duplicateModal!: ModalDirective;
  duplicatesActive: any[] = [];
  duplicatesBlocked: any[] = [];
  totalGroupCount = 0;
  showActive = true;
  showBlocked = true;

  // Deactivation modal
  @ViewChild('deactivateModal') public deactivateModal!: ModalDirective;
  deactivateCandidates: TransferRequest[] = [];
  deactivateFiltered: TransferRequest[] = [];
  deactivateSelected: Set<number> = new Set();
  deactivateFilterSector = '-1';
  deactivateFilterWeek = '-1';
  deactivateFilterRef = '';
  deactivateProgress: { current: number; total: number } | null = null;
  deactivateResults: { code: string; success: boolean; reason: string; scheduleDate?: string }[] = [];
  _deactivateFailedIds: number[] = [];
  deactivateConfirmStep = false;
  deactivateHoldProgress = 0;
  private _holdInterval: any = null;
  deactivationReasonLock = DeactivationReason.WithinLockWindow;
  deactivationReasonStopped = DeactivationReason.StoppedByLock;

  constructor(
    @Inject(SESSION_STORAGE) private _storage: WebStorageService,
    private _excel: ExcelUtility,
    private _facadeStore: StoreFacade,
    private _datePipe: DatePipe,
    private _route: ActivatedRoute,
    private _router: Router,
    private _transferRequestFacade: TransferRequestFacade,
    private _catalogFacade: CatalogDetFacade,
    private _facadeLog: LoggerLayoutsFacade,
    public strings: Strings,
    public datepipe: DatePipe,
    private localeService: BsLocaleService,
    private _bulkFacade: TransferRequestBulkFacade,
    private _bulkSignalR: TransferBulkSignalRService
  ) {
    this._storage.set('moduleUrl', this._router.url);
  }

  ngOnInit() {
    this.isSpanish = this.strings.getLanguageIsSpanish();
    this.availableOrganizations = this.strings.getAvailableOrganizations();
    this.tenantId = this.strings.getTenant();
    this.localeService.use(this.strings.getLanguage());

    this.lstOrganization = this.availableOrganizations.filter(item => item.tenantId === this.tenantId);
    this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
    this.messagesTable.totalMessage = 'Total';

    this.fillWeeks();
    this.getWeeks();
    this.validatePermissions();

    if (!this.isSpanish) {
      this.language = 1;
    }

    this.initResizeObserver();

    this._route.queryParams.subscribe(params => {
      if (params['startDate'] !== undefined && params['endDate'] !== undefined) {
        this.txtStartDateResumen = new Date(params['startDate']);
        this.startDateResumen = new Date(params['startDate']);
        this.txtEndDateResumen = new Date(params['endDate']);
        this.endDateResumen = new Date(params['endDate']);
      }
      if (params['strOrganizationSelected'] !== undefined) {
        this.strOrganizationSelected = params['strOrganizationSelected'];
        const organizationIds = this.strOrganizationSelected.split(',');
        const organizationSelectedAux: Organization[] = [];
        this.availableOrganizations.forEach(element => {
          organizationIds.forEach(id => {
            if (element.organizationId === id) {
              organizationSelectedAux.push(element)
            }
          })
        })
        this.selectedOrganizations = organizationSelectedAux;
        this.getStores();
        this.searchTransfer = true;
      }
      if (this.searchTransfer) {

        if (params['storeOriginId'] !== undefined && Number(params['storeOriginId']) > -1) {
          this.storeOriginId = Number(params['storeOriginId']);
        }
        if (params['storeDestinyId'] !== undefined && Number(params['storeDestinyId']) > -1) {
          this.storeDestinyId = Number(params['storeDestinyId']);
        }
        if (params['sector'] !== undefined && Number(params['sector']) > -1) {
          this.sectorId = Number(params['sector']);
        }
        if (params['week'] !== undefined && Number(params['week']) > -1) {
          this.week = Number(params['week']);
        }
        this.getTransferRequestByDates();
      }
    });

    // Feature 46570 - conectar SignalR para avisos de fin de carga.
    this.initBulkSignalR();
  }

  ngOnDestroy() {
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
    }
    this.cancelHoldDeactivate();
    // Feature 46570 - limpiar SignalR
    if (this._bulkSignalRSub) {
      this._bulkSignalRSub.unsubscribe();
    }
    // Feature 46570 - detener auto-refresh de la lista de cargas
    this.stopBulkJobsPolling();
    const user = this._storage.get('user');
    const email = user && user.email ? user.email : (user ? user.account : '');
    this._bulkSignalR.stop(email).catch(() => { /* best-effort */ });
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: BeforeUnloadEvent): void {
    if (this.loading) {
      event.preventDefault();
      event.returnValue = '';
    }
  }

  canDeactivate(): boolean {
    if (!this.loading) { return true; }
    return confirm(this.strings.GetText(res.ConfirmLeaveWhileProcessing));
  }

  private initResizeObserver() {
    const container = document.querySelector('.maincontainer');
    if (container) {
      this._resizeObserver = new ResizeObserver(() => {
        if (this.table) {
          this.table.recalculate();
        }
      });
      this._resizeObserver.observe(container);
    }
  }

  private getStores() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.GettingTheStores);
    this.storesOrigin = [];
    this.storesDestiny = [];
    this._facadeStore.GetParticipateQuantum().subscribe(
      response => {
        this.loading = false;
        const lstStores = response.data;
        lstStores.forEach(store => {
          if (this.selectedOrganizations.find(item => item.organizationId === store.organizationId) !== undefined) {
            this.storesOrigin.push(store);
            this.storesDestiny.push(store);
          }
        });
        this.getSectors();
      }, err => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertStoresCouldNotBeObtained), 'danger', 'general');
      }
    );

  }

  private getSectors() {
    this._catalogFacade.Get(36).subscribe(
      response => {
        this.sectors = response.data;
      }, err => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertCouldNotGetTheSectors), 'danger', 'general');
      }
    );
    this.loading = false;
  }

  private getWeeks() {
    this.loading = true;
    for (let i = 1; i <= 52; i++) {
      this.weeks.push(
        {
          'week': i
          , 'name': i
        }
      );
    }
    this.loading = false;
  }

  private fillWeeks() {
    for (let i = 1; i < 53; i++) {
      this.listWeek.push(i);
    }
  }

  private validateFile(name: String, extension: String) {
    const ext = name.substring(name.lastIndexOf('.') + 1);
    const normalized = ext === 'xls' ? 'xlsx' : ext;
    return normalized.toLowerCase() === extension;
  }

  private transferRequestValid() {
    return this.txtWeek !== -1 && this.organizationId !== '-1' && this.excelRows.length > 0;
  }

  // añadir alert
  addAlert(message: String, type: String, fileType: String) {
    if (fileType === 'excel') {
      this.alertsFileExcel = [];
      this.alertsFileExcel.push({
        type: type,
        msg: message
      });
    } else {
      this.generalAlerts = [];
      this.generalAlerts.push({
        type: type,
        msg: message,
        timeout: 5000
      });
    }

  }

  // cerrar alert
  onClosed(dismissedAlert: AlertComponent, fileType: String): void {
    if (fileType === 'excel') {
      this.alertsFileExcel = this.alertsFileExcel.filter(alert => alert !== dismissedAlert);
    } else {
      this.generalAlerts = this.generalAlerts.filter(alert => alert !== dismissedAlert);
    }
  }

  // Save Transfer
  newTransfers() {
    this.alertsFileExcel = [];
    this.excelRows = [];
    this.txtWeek = -1;
    this.organizationId = '-1';
    this.txtReference = '';
    this.txtYear = new Date().getFullYear();
    this.txtMinDateAdd = new Date();
    this.txtMaxDateAdd = new Date();
    this.txtStartDate = this.getNowUTCLess6hr();
    this.txtEndDate = this.txtStartDate = this.getNowUTCLess6hr();

    this.modal.config.ignoreBackdropClick = true;
    this.isDisabledSaveTransfer = false;
    this._skipDuplicateCheck = false;
    this._skipMultiRowCheck = false;
    this._skipMaxVersionCheck = false;
    this.maxVersionBlockedCodes = [];
    this.duplicatesActive = [];
    this.duplicatesBlocked = [];
    this.totalGroupCount = 0;
    this.batchResultMessage = '';
    this._failedBatches = new Map();
    this.batchProgress = null;
    this.validatedData = null!;
    this.validateMessage = '';
    this.resetFileInput();
    this.modal.show();
  }

  onChangeStartDate(value: Date) {
    this.txtStartDate = value;
  }

  onChangeEndDate(value: Date) {
    this.txtEndDate = value;
    this.txtMaxDateAdd = value;
  }

  uploadExcel(event: any) {
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(event.target);

    if (target.files.length !== 1) {
      this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertSelectOnlyOneFile), 'danger', 'excel');
      this.logIncident(this.strings.GetText(res.AlertSelectOnlyOneFile));
      return;
    }
    // check file is valid
    if (!this.validateFile(target.files[0].name, 'xlsx')) {
      this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertOnlyXlsxfilesAreAccepted), 'danger', 'excel');
      this.logIncident(this.strings.GetText(res.AlertOnlyXlsxfilesAreAccepted));

      return;
    }

    this.fileNameModal = event.target.files[0].name;

    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(target.files[0]);
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      this.excelData = <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1 }));
      this.excelRows = [];
      this.excelData.forEach((element, index) => {
        if (index !== 0) {
          if (element.length > 0) {
            const data = new TransferRequestExcelDto();
            data.StoreOriginCode = element[0];
            data.StoreOrigin = (isNaN(Number.parseInt(element[0])) ? element[0] : '-1');
            data.StoreDestiny = (isNaN(Number.parseInt(element[1])) ? element[1] : '-2');
            data.StoreDestinyCode = element[1];
            data.OrganizationId = this.organizationId.toString();
            data.StyleVariety = element[2];
            data.Season = element[3];
            data.SizeName = element[4];
            data.Size = element[4];
            data.SizeGroupDetCode = element[4];
            data.Comment = element[5];
            data.SectorAuxiliary = element[6];
            data.Sector = element[6];
            data.Quantity = Number.isNaN(Number.parseInt(element[7])) || element[7] === null || element[7] === '' ? 0 : Number.parseInt(element[7]);
            this.excelRows.push(data);
          }
        }
      });
    };
    this.addAlert(this.strings.GetText(res.File) + ' ' + this.fileNameModal + ' ' + this.strings.GetText(res.UploadedCorrectly), 'success', 'excel');

    // Actualizar el texto del elemento label con el nombre del archivo
    const label = document.querySelector('.custom-file-label');
    label!.textContent = this.fileNameModal;
  }

  // === Local validations (no backend needed) ===

  private validateMultiRowLocal(): string[] {
    const groups = new Map<string, number>();
    for (const row of this.excelRows) {
      const key = `${row.StoreOriginCode}|${row.StoreDestinyCode}|${row.StyleVariety}|${row.Size}`;
      groups.set(key, (groups.get(key) || 0) + 1);
    }
    const duplicates: string[] = [];
    groups.forEach((count, key) => {
      if (count > 1) {
        duplicates.push(key.replace(/\|/g, ' -> '));
      }
    });
    return duplicates;
  }

  private validateQuantityLocal(): string[] {
    return this.excelRows
      .filter(r => r.Quantity < 1)
      .map(r => `${r.StoreOriginCode} -> ${r.StoreDestinyCode} -> ${r.StyleVariety} -> ${r.Size} -> ${r.Quantity}`);
  }

  // === Batch helpers ===

  private delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  private async callWithRetry<T>(fn: () => Promise<T>, retries = TransferRequestInfo.MAX_RETRIES): Promise<T> {
    for (let attempt = 1; attempt <= retries; attempt++) {
      try {
        return await fn();
      } catch (err) {
        if (attempt === retries) { throw err; }
        await this.delay(TransferRequestInfo.RETRY_DELAY_BASE_MS * Math.pow(2, attempt - 1));
      }
    }
    throw new Error('Max retries reached');
  }

  private toPromise<T>(obs: any): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      obs.subscribe((r: T) => resolve(r), (e: any) => reject(e));
    });
  }

  private chunkArray<T>(arr: T[], size: number): T[][] {
    const chunks: T[][] = [];
    for (let i = 0; i < arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  }

  // === New batched validation flow ===

  async validateExcelBatched(onMultiRowWarning: (msg: string) => void) {
    // Phase 0: Local validations
    const quantityErrors = this.validateQuantityLocal();
    if (quantityErrors.length > 0) {
      const msg = this.strings.GetText(res.ErrorTransferStyleQuantity) + '\n' + quantityErrors.join('\n');
      this.addAlert('<strong>' + msg + '</strong>', 'danger', 'excel');
      this.logIncident(msg);
      this.isDisabledSaveTransfer = false;
      this.loading = false;
      return;
    }

    if (!this._skipMultiRowCheck) {
      const multiRowDups = this.validateMultiRowLocal();
      if (multiRowDups.length > 0) {
        const msg = this.strings.GetText(res.ErrorTransferStyleSizeMultiRow) + '\n' + multiRowDups.join('\n');
        this.isDisabledSaveTransfer = false;
        this.loading = false;
        onMultiRowWarning(msg);
        return;
      }
    }
    this._skipMultiRowCheck = false;

    // Build base DTO
    const data = new TransferRequestDto();
    data.language = this.language;
    data.year = this.txtYear;
    data.week = this.txtWeek;
    data.reference = this.txtReference;
    data.startDate = this.txtStartDate;
    data.endDate = this.txtEndDate;
    data.data = this.excelRows;
    data.organizationId = this.organizationId;

    // Phase 1: Validate Stores (single call)
    this.messageLoader = `${this.strings.GetText(res.ValidatingStores)} (1/3)`;
    try {
      const storeResp = await this.callWithRetry(() =>
        this.toPromise<any>(this._transferRequestFacade.PostValidateStores(data))
      );
      if (!storeResp.completed) {
        const msg = this.getMessageErrorDataValidation(storeResp.message);
        this.addAlert('<strong>' + msg + '</strong>', 'danger', 'excel');
        this.logIncident(msg);
        this.isDisabledSaveTransfer = false;
        this.loading = false;
        return;
      }
      this.validatedData = storeResp.data;
      // Normalize camelCase response to match DTO PascalCase properties
      if (!this.validatedData.StoresValidated && (storeResp.data as any).storesValidated) {
        this.validatedData.StoresValidated = (storeResp.data as any).storesValidated;
      }
    } catch (err) {
      this.addAlert('<strong>' + String(err) + '</strong>', 'danger', 'excel');
      this.logIncident(String(err));
      this.isDisabledSaveTransfer = false;
      this.loading = false;
      return;
    }

    // Phase 2: Validate Styles by batch
    this.messageLoader = `${this.strings.GetText(res.ValidatingStyles)} (2/3)`;
    const uniqueStyles = this.getUniqueStyles();
    const styleChunks = this.chunkArray(uniqueStyles, TransferRequestInfo.BATCH_SIZE_STYLES);
    const allStylesValidated: any[] = [];
    let styleErrors = '';

    for (let i = 0; i < styleChunks.length; i++) {
      this.messageLoader = `${this.strings.GetText(res.ValidatingStyles)} (2/3) [${i + 1}/${styleChunks.length}]`;
      const batchDto = { ...this.validatedData, data: this.buildStyleBatchData(styleChunks[i]) };
      try {
        const resp = await this.callWithRetry(() =>
          this.toPromise<any>(this._transferRequestFacade.PostValidateStylesBatch(batchDto as any))
        );
        if (resp.data && (resp.data.StyleSizesValidated || resp.data.styleSizesValidated)) {
          allStylesValidated.push(...(resp.data.StyleSizesValidated ?? resp.data.styleSizesValidated ?? []));
        }
        if (!resp.completed && resp.message) {
          styleErrors += resp.message;
        }
      } catch (err) {
        this.addAlert('<strong>' + String(err) + '</strong>', 'danger', 'excel');
        this.logIncident(String(err));
        this.isDisabledSaveTransfer = false;
        this.loading = false;
        return;
      }
    }

    this.validatedData.StyleSizesValidated = allStylesValidated;

    if (styleErrors.length > 0) {
      const msg = this.getMessageErrorDataValidation(styleErrors, true);
      this.addAlert('<strong>' + msg + '</strong>', 'danger', 'excel');
      this.logIncident(msg);
      this.isDisabledSaveTransfer = false;
      this.loading = false;
      return;
    }

    // Phase 3: PreValidate Duplicates by batch
    this.messageLoader = `${this.strings.GetText(res.ValidatingDuplicates)} (3/3)`;
    await this.preValidateDuplicatesBatched();
  }

  private getUniqueStyles(): { styleVariety: string; size: string }[] {
    const seen = new Set<string>();
    const result: { styleVariety: string; size: string }[] = [];
    for (const row of this.excelRows) {
      const key = `${row.StyleVariety}|${row.Size}`;
      if (!seen.has(key)) {
        seen.add(key);
        result.push({ styleVariety: row.StyleVariety, size: row.Size });
      }
    }
    return result;
  }

  private buildStyleBatchData(styles: { styleVariety: string; size: string }[]): any[] {
    // Build minimal data array containing only rows that match these styles
    const styleSet = new Set(styles.map(s => `${s.styleVariety}|${s.size}`));
    return this.excelRows.filter(r => styleSet.has(`${r.StyleVariety}|${r.Size}`));
  }

  saveTransferRequest() {
    this.loading = true;
    this.isDisabledSaveTransfer = true;
    if (this.transferRequestValid()) {
      this.validateExcelBatched(
        (msg) => {
          this.validateMessage = msg;
          this.warningModal.show();
        }
      );
    } else {
      this.loading = false;
      this.isDisabledSaveTransfer = false;
      this.addAlert('<strong>' + this.strings.GetText(res.AlertYouMustFillTheFieldsOfTheForm) + '</strong>', 'danger', 'excel');
      this.logIncident(this.strings.GetText(res.AlertYouMustFillTheFieldsOfTheForm));
    }
  }

  postTransferRequest() {
    this.warningModal.hide();
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.SavingData);
    const data = new TransferRequestDto();
    data.language = this.language;
    data.year = this.txtYear;
    data.week = this.txtWeek;
    data.reference = this.txtReference;
    data.startDate = this.txtMinDate;
    data.endDate = this.txtMaxDate;
    data.organizationId = this.organizationId.toString();
    data.data = this.excelRows;
    this._transferRequestFacade.PostTransferRequest(data).subscribe(
      response => {
        this.loading = false;
        if (response.completed) {
          this.addAlert('<strong>' + response.message + '</strong>', 'success', 'general');
          this.modal.hide();
          this.getTransferRequestByDates();
        } else {
          this.addAlert('<strong>' + response.message + '</strong>', 'danger', 'excel');
          this.logIncident(response.message.toString());
        }
      },
      err => {
        this.loading = false;
        this.addAlert('<strong>' + err + '</strong>', 'danger', 'excel');
        this.logIncident(String(err));
      }
    );
  }

  postTransferRequestByOrganization() {
    this.warningModal.hide();
    this.loading = true;
    this.isDisabledSaveTransfer = true;
    if (this.maxVersionBlockedCodes.length > 0) {
      // User confirmed to continue without blocked codes
      this._skipMaxVersionCheck = true;
      this.validatedData.skipMaxVersionCheck = true;
      this.maxVersionBlockedCodes = [];
      this.sendByBatches();
    } else if (this.validatedData != null && this.validatedData.data != null) {
      if (this._skipDuplicateCheck) {
        this.validatedData.skipDuplicateCheck = true;
        this.sendByBatches();
      } else {
        this.preValidateDuplicatesBatched();
      }
    } else {
      // Multi-row warning interrupted before phases 1-3; resume full validation
      this._skipMultiRowCheck = true;
      this.validateExcelBatched(() => {});
    }
  }

  private async preValidateDuplicatesBatched() {
    this.loading = true;
    this.messageLoader = `${this.strings.GetText(res.ValidatingDuplicates)} (3/3)`;

    // Build batches from groupByBatch keys (each key = one code)
    const groups = this.groupByBatch(this.validatedData.data);
    const keys = Array.from(groups.keys());
    const keyChunks = this.chunkArray(keys, TransferRequestInfo.BATCH_SIZE_DUPLICATES);
    const allDuplicates: any[] = [];
    let maxAllowed = 9;

    let failedBatchCount = 0;
    for (let i = 0; i < keyChunks.length; i++) {
      this.messageLoader = `${this.strings.GetText(res.ValidatingDuplicates)} (3/3) [${i + 1}/${keyChunks.length}]`;
      const chunkData: any[] = [];
      for (const key of keyChunks[i]) {
        chunkData.push(...(groups.get(key) || []));
      }
      const batchDto: TransferRequestDto = { ...this.validatedData, data: chunkData };
      try {
        const resp = await this.callWithRetry(() =>
          this.toPromise<any>(this._transferRequestFacade.PostPreValidateDuplicatesBatch(batchDto as any))
        );
        if (resp.completed && resp.data && resp.data.length > 0) {
          allDuplicates.push(...resp.data);
        }
        if (resp.completed && resp.message && !isNaN(Number(resp.message))) {
          maxAllowed = Number(resp.message);
        }
      } catch (err) {
        failedBatchCount++;
        console.warn(`PreValidateDuplicates batch ${i + 1}/${keyChunks.length} failed:`, err);
      }
    }

    if (failedBatchCount > 0) {
      // Some or all batches failed — cannot reliably determine duplicates
      this.loading = false;
      this.isDisabledSaveTransfer = false;
      this.addAlert('<strong>' + this.strings.GetText(res.ErrorTransferBatchPartial)
        + ` (${failedBatchCount}/${keyChunks.length} batches failed in duplicate validation)</strong>`, 'danger', 'excel');
      return;
    }

    const activeAll = allDuplicates.filter(d => d.status === TransferRequestInfo.STATUS_ACTIVE);
    this.duplicatesBlocked = activeAll.filter(d => d.maxVersion >= maxAllowed);
    this.duplicatesActive = activeAll.filter(d => d.maxVersion < maxAllowed);
    this.totalGroupCount = keys.length;

    if (this.duplicatesActive.length > 0 || this.duplicatesBlocked.length > 0) {
      this.loading = false;
      this.duplicateModal.show();
    } else {
      if (allDuplicates.length > 0) {
        this.validatedData.skipDuplicateCheck = true;
      }
      this.sendByBatches();
    }
  }

  confirmDuplicates() {
    this.duplicateModal.hide();
    this._skipDuplicateCheck = true;
    this.validatedData.skipDuplicateCheck = true;
    if (this.duplicatesBlocked.length > 0) {
      this._skipMaxVersionCheck = true;
      this.validatedData.skipMaxVersionCheck = true;
      // Filtrar datos removiendo filas de códigos bloqueados
      const blockedKeys = new Set(
        this.duplicatesBlocked.map(d =>
          `${d.storeOriginCode}|${d.storeDestinyCode}|${d.sectorAuxiliary}`
        )
      );
      this.validatedData.data = this.validatedData.data.filter((row: any) => {
        const origin = row.StoreOriginCode ?? row.storeOriginCode;
        const destiny = row.StoreDestinyCode ?? row.storeDestinyCode;
        const sector = row.Sector ?? row.sector;
        return !blockedKeys.has(`${origin}|${destiny}|${sector}`);
      });
    }
    this.sendByBatches();
  }

  cancelDuplicates() {
    this.duplicateModal.hide();
    this.isDisabledSaveTransfer = false;
    this.loading = false;
    this._skipDuplicateCheck = false;
    this._skipMaxVersionCheck = false;
    this.maxVersionBlockedCodes = [];
    this.duplicatesActive = [];
    this.duplicatesBlocked = [];
    this.totalGroupCount = 0;
  }

  private groupByBatch(data: any[]): Map<string, any[]> {
    return data.reduce((map, row) => {
      const origin = row.StoreOriginCode ?? row.storeOriginCode;
      const destiny = row.StoreDestinyCode ?? row.storeDestinyCode;
      const sector = row.Sector ?? row.sector;
      const key = `${origin}|${destiny}|${sector}`;
      if (!map.has(key)) {
        map.set(key, []);
      }
      map.get(key).push(row);
      return map;
    }, new Map<string, any[]>());
  }

  private buildBatchDto(rows: any[]): TransferRequestDto {
    const styleKeys = new Set(
      rows.map(r => `${(r.StyleVariety ?? r.styleVariety)}|${(r.Size ?? r.size)}`)
    );
    const filteredStyles = (this.validatedData.StyleSizesValidated || []).filter(s =>
      styleKeys.has(`${s.styleVariety}|${s.sizeName}`)
    );
    return { ...this.validatedData, data: rows, StyleSizesValidated: filteredStyles };
  }

  private async postBatch(batch: TransferRequestDto): Promise<{ completed: boolean; message: string }> {
    try {
      const response = await this.callWithRetry(() =>
        this.toPromise<any>(this._transferRequestFacade.PostTransferRequestByOrganization(batch))
      );
      return { completed: response.completed, message: response.message || '' };
    } catch (error: any) {
      return { completed: false, message: error?.status ? `HTTP ${error.status}` : String(error) };
    }
  }

  private async sendByBatches(batches?: Map<string, TransferRequestDto>) {
    this.isDisabledSaveTransfer = true;
    this.loading = true;
    this.batchResultMessage = '';
    this.messageLoader = this.strings.GetText(res.CreatingRequests);

    const groups: Map<string, any[] | TransferRequestDto> = batches ?? this.groupByBatch(this.validatedData.data);
    this._failedBatches = new Map();
    this.batchProgress = { current: 0, total: groups.size, failed: [] };

    for (const [key, batchOrRows] of groups) {
      const batch: TransferRequestDto = batches
        ? batchOrRows as TransferRequestDto
        : this.buildBatchDto(batchOrRows as any[]);
      const result = await this.postBatch(batch);
      this.batchProgress = { ...this.batchProgress, current: this.batchProgress.current + 1 };
      this.messageLoader = `${this.strings.GetText(res.CreatingRequests)} (${this.batchProgress.current}/${this.batchProgress.total})`;

      if (!result.completed) {
        const errorMsg = this.resolveBatchErrorMessage(result.message);
        if (errorMsg === null) {
          this.isDisabledSaveTransfer = true;
          this.modal.hide();
          this.batchProgress = null;
          this.loading = false;
          return;
        }
        if (errorMsg === 'SKIP') {
          // Duplicado: ya existe, tratarlo como éxito
          continue;
        }
        this.batchProgress = { ...this.batchProgress, failed: [...this.batchProgress.failed, key] };
        this._failedBatches.set(key, batch);
        this.logIncident(errorMsg);
      }
    }

    const failed = this.batchProgress.failed;
    this.batchProgress = null;
    this.loading = false;

    if (failed.length === 0) {
      this._failedBatches = new Map();
      this.isDisabledSaveTransfer = false;
      this.addAlert('<strong>' + this.strings.GetText(res.TransferRequestCreatedSuccessfully) + '</strong>', 'success', 'general');
      this.modal.hide();
      const label = document.querySelector('.custom-file-label');
      if (label) {
        label.textContent = '';
      }
      if (this.selectedOrganizations.length > 0) {
        this.getTransferRequestByDates();
      }
    } else {
      this.isDisabledSaveTransfer = false;
      const failedList = failed.map(k => k.replace(/\|/g, ' → ')).join('<br>');
      this.batchResultMessage = '<strong>' + this.strings.GetText(res.ErrorTransferBatchPartial) + '</strong><br>' + failedList;
    }
  }

  retryFailedBatches() {
    if (this._failedBatches.size === 0) {
      return;
    }
    this.batchResultMessage = '';
    const pending = new Map(this._failedBatches);
    this._failedBatches = new Map();
    this.sendByBatches(pending);
  }

  downloadFailedBatches() {
    if (this._failedBatches.size === 0) {
      return;
    }
    const data: any[] = [];
    this._failedBatches.forEach(batch => {
      (batch.data as any[]).forEach(row => {
        data.push({
          [this.strings.GetText(res.OriginStore)]: row.StoreOriginCode ?? row.storeOriginCode,
          [this.strings.GetText(res.DestinationStore)]: row.StoreDestinyCode ?? row.storeDestinyCode,
          [this.strings.GetText(res.StyleVariety)]: row.StyleVariety ?? row.styleVariety,
          [this.strings.GetText(res.Season)]: row.Season ?? row.season,
          [this.strings.GetText(res.Size)]: row.Size ?? row.size,
          [this.strings.GetText(res.Comments)]: row.Comment ?? row.comment,
          [this.strings.GetText(res.Sector)]: row.Sector ?? row.sector,
          [this.strings.GetText(res.Quantity)]: row.Quantity ?? row.quantity
        });
      });
    });
    this._excel.exportAsExcelFile(data, this.strings.GetText(res.ExportFileNamePendingTransfers));
  }

  /**
   * Retorna:
   * - string: mensaje de error (lote falló)
   * - null: error fatal, detener todo
   * - 'SKIP': lote duplicado, tratarlo como éxito (solo cuando usuario ya confirmó)
   */
  private resolveBatchErrorMessage(message: string): string | null {
    if (message.includes('ErrorTransferMaxVersionsReached')) {
      const codes = message.split('|')[1] || '';
      this.batchResultMessage = '<strong>' + this.strings.GetText(res.ErrorTransferMaxVersionsReached)
        + '</strong><br>' + codes.split(',').join('<br>');
      return null;
    }

    if (message.includes('ErrorTransferMaxVersionsPartial')) {
      const codes = (message.split('|')[1] || '').split(',').filter(c => c.trim());
      this.maxVersionBlockedCodes = codes;
      // Mostrar warning y preguntar al usuario
      this.loading = false;
      this.batchProgress = null;
      const codeList = codes.join('<br>');
      this.validateMessage = '<strong>' + this.strings.GetText(res.ErrorTransferMaxVersionsPartial)
        + '</strong><br><br>' + codeList
        + '<br><br>' + this.strings.GetText(res.ErrorTransferMaxVersionsPartialConfirm);
      this.warningModal.show();
      return null;
    }

    if (message.includes('ErrorTransferDuplicateToday')) {
      if (this._skipDuplicateCheck) {
        return 'SKIP';
      }
      // Pre-validación no detectó pero el backend sí — informar al usuario
      this.batchResultMessage = '<strong>' + this.strings.GetText(res.ErrorTransferDuplicateToday) + '</strong>';
      return null;
    }
    if (message.includes('ErrorStartEndDateLessThanToday')) return this.strings.GetText(res.SmallerDateThan);
    if (message.includes('ErrorStartDateGreaterThanEnd')) return this.strings.GetText(res.GreaterDateThan);
    if (message.includes('ErrorTransferTaskCreate')) return this.strings.GetText(res.ErrorTransferTaskCreate);
    if (message.includes('ErrorTransferCountToCreate')) return this.strings.GetText(res.ErrorTransferCountToCreate);
    if (message.includes('ErrorTransferWithDetCreate')) return this.strings.GetText(res.ErrorTransferWithDetCreate);
    // Error HTTP u otro no identificado
    return message.length > 0 ? message : this.strings.GetText(res.ErrorUnknown);
  }

  private logIncident(message: string) {
    const userInfo = this._storage.get('user');
    const log = new LoggerLayout();
    log.message = message;
    log.layoutIncidence = 'transfer-corporate';
    log.userName = userInfo.account;
    log.incidenceType = 1;
    this._facadeLog.AddNewIncident(log).subscribe();
  }

  // filter Transfer
  UpdateSelection() {
    this.rows = this._filteredData;

    if (this.storeOriginId.toString() !== '-1') {
      this.rows = this.rows.filter(item => {
        return (item.storeOriginId.toString() === this.storeOriginId.toString());
      });
    }

    if (this.storeDestinyId.toString() !== '-1') {
      this.rows = this.rows.filter(item => {
        return (item.storeDestinationId.toString() === this.storeDestinyId.toString());
      });
    }

    if (this.week.toString() !== '-1') {
      this.rows = this.rows.filter(item => {
        return (item.week.toString() === this.week.toString());
      });
    }

    if (this.sectorId.toString() !== '-1') {
      this.rows = this.rows.filter(item => {
        return (item.catDetSectorId.toString() === this.sectorId.toString());
      });
    }

    if (this.txtSearch.trim().length > 0) {
      this.updateFilter();
    }
  }

  updateFilter() {
    const val = this.txtSearch.toLowerCase();
    // get the key names of each column in the dataset
    const keys = Object.keys(this._filteredData[0]);
    // assign filtered matches to the active datatable
    this.rows = this.rows.filter((item: any) => {
      return keys.some(key => {
        return item[key] != null && (item[key].toString().toLowerCase().indexOf(val) !== -1 || !val);
      });
    });
  }

  // Save excel
  downloadReport() {
    if (this.rows.length > 0) {
      const data: any = [];
      this.rows.sort((a, b) => new Date(b.endDate).getTime() - new Date(a.startDate).getTime());
      this.rows.forEach(row => {
        let info: any;
        if (this.isSpanish) {
          info = {
            [this.strings.GetText(res.TransferReference)]: row.code,
            [this.strings.GetText(res.OriginStore)]: row.storeOriginName,
            [this.strings.GetText(res.DestinationStore)]: row.storeDestinationName,
            'Sector': row.catDetSectorName,
            [this.strings.GetText(res.Week)]: row.week,
            [this.strings.GetText(res.ReferenceRequest)]: row.reference,
            [this.strings.GetText(res.RequestDate)]: this._datePipe.transform(row.startDate, 'dd/MM/yyyy'),
            [this.strings.GetText(res.Deadline)]: this._datePipe.transform(row.endDate, 'dd/MM/yyyy'),
            [this.strings.GetText(res.Requested)]: row.quantityRequested,
            [this.strings.GetText(res.Rejected)]: row.quantityRejected,
            [this.strings.GetText(res.Sent)]: row.quantitySend,
            [this.strings.GetText(res.PercentageSent)]: row.percentSend,
            [this.strings.GetText(res.Received)]: row.quantityReceived,
            [this.strings.GetText(res.PercentageReceived)]: row.percentReceived
          };
        } else {
          info = {
            [this.strings.GetText(res.TransferReference)]: row.code,
            [this.strings.GetText(res.OriginStore)]: row.storeOriginName,
            [this.strings.GetText(res.DestinationStore)]: row.storeDestinationName,
            'Sector': row.catDetSectorName,
            [this.strings.GetText(res.Week)]: row.week,
            [this.strings.GetText(res.ReferenceRequest)]: row.reference,
            [this.strings.GetText(res.RequestDate)]: this._datePipe.transform(row.startDate, 'MM/dd/yyyy'),
            [this.strings.GetText(res.Deadline)]: this._datePipe.transform(row.endDate, 'MM/dd/yyyy'),
            [this.strings.GetText(res.Requested)]: row.quantityRequested,
            [this.strings.GetText(res.Rejected)]: row.quantityRejected,
            [this.strings.GetText(res.Sent)]: row.quantitySend,
            [this.strings.GetText(res.PercentageSent)]: row.percentSend,
            [this.strings.GetText(res.Received)]: row.quantityReceived,
            [this.strings.GetText(res.PercentageReceived)]: row.percentReceived
          };
        }
        data.push(info);
      });
      this._excel.exportAsExcelFile(data, 'data');
    } else {
      this.addAlert(this.strings.GetText(res.AlertInfoMustBeLoadedToGenerateTheFile), 'danger', 'general');
      this.logIncident(this.strings.GetText(res.AlertInfoMustBeLoadedToGenerateTheFile));
    }
  }

  downloadLayout() {
    const link = document.createElement('a');
    if (this.isSpanish) {
      link.download = 'Layout_Traspaso_Corporativo.xlsx';
    }
    else {
      link.download = 'Layout_Corporate_Transfer.xlsx';
    }
    link.href = 'assets/layout/Layout_Traspasos_Corporativo.xlsx';
    link.click();
  }

  // go toDetail
  onViewDetail(id: any) {
    const navigationExtras: NavigationExtras = {
      queryParams: {
        'strOrganizationSelected': this.strOrganizationSelected,
        'startDate': this.startDateResumen,
        'endDate': this.endDateResumen,
        'storeOriginId': this.storeOriginId,
        'storeDestinyId': this.storeDestinyId,
        'sector': this.sectorId,
        'week': this.week,
      }
    };
    this._router.navigate(['/transfer/corporate/', id], navigationExtras);
  }

  validateDate(dateString: string): boolean {
    const today = new Date();
    const toValid = new Date(dateString.split('T')[0]);
    return toValid > today;
  }

  cancelTransfer(id: any) {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.DeletingTransfer);
    this._transferRequestFacade.DeleteTransferRequest(id).subscribe(
      response => {
        this.loading = false;
        if (response.completed) {
          if (response.data) {
            this.addAlert('<strong>' + this.strings.GetText(res.AlertHasBeenRemovedSuccessfully) + '</strong>', 'success', 'general');
            this.getTransferRequestByDates();
          } else {
            this.addAlert('<strong>' + response.message + '</strong>', 'danger', 'excel');
            this.logIncident(response.message.toString());
          }
        } else {
          this.addAlert('<strong>' + response.message + '</strong>', 'danger', 'excel');
          this.logIncident(response.message.toString());
        }
      },
      err => {
        this.loading = false;
        this.addAlert('<strong>' + err + '</strong>', 'danger', 'excel');
        this.logIncident(String(err));
      }
    );
  }

  validatePermissions() {
    this.permissionsList = this._storage.get('permissions');
    this.permissionsList.forEach(element => {
      if (element.name === Permissions.GeneralAccess || element.name === Permissions.AdminTraspasoCorpoCreate) {
        this.visibleAdd = true;
      }
    });

    this.permissionsList.forEach(element => {
      if (element.name === Permissions.GeneralAccess || element.name === Permissions.AdminTraspasoCorpoEdit) {
        this.visibleEdit = true;
      }
    });

    // Feature 46570 - visibilidad total de cargas (directivo/admin) por permiso.
    this.bulkCanSeeAll = this.permissionsList.some(p =>
      p.name === Permissions.GeneralAccess || p.name === Permissions.AdminTraspasoCorpoRead);
  }

  // ===================== Feature 46570 - Carga masiva (flujo nuevo) =====================

  /** Suscribe SignalR al grupo del usuario para recibir el fin de carga. */
  private initBulkSignalR() {
    const user = this._storage.get('user');
    const email = user && user.email ? user.email : (user ? user.account : '');
    if (!email) { return; }

    this._bulkSignalR.start(email).catch(() => { /* best-effort: el usuario puede refrescar manualmente */ });

    this._bulkSignalRSub = this._bulkSignalR.jobFinished$.subscribe(info => {
      const msg = this.strings.GetText(res.BulkJobFinishedNotice)
        .replace('{0}', String(info.success))
        .replace('{1}', String(info.failed));
      this.addAlert('<strong>' + msg + '</strong>', info.failed > 0 ? 'warning' : 'success', 'general');
      // Si el panel de cargas está abierto, refrescar la lista.
      if (this.bulkLogsModal && (this.bulkLogsModal as any).isShown) {
        this.loadBulkJobs();
      }
    });
  }

  /** Nuevo guardado asíncrono: sube el layout y responde de inmediato (202). */
  saveTransferRequestBulk() {
    if (this.txtWeek === -1 || this.organizationId === '-1' || this.excelRows.length === 0) {
      this.addAlert('<strong>' + this.strings.GetText(res.AlertYouMustFillTheFieldsOfTheForm) + '</strong>', 'danger', 'excel');
      return;
    }

    this.isDisabledSaveTransfer = true;
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.SavingData);

    const dto = new TransferRequestBulkUploadDto();
    dto.language = this.language;
    dto.week = this.txtWeek;
    dto.year = this.txtYear;
    dto.reference = this.txtReference;
    dto.organizationId = this.organizationId.toString();
    dto.startDate = this.txtStartDate;
    dto.endDate = this.txtEndDate;
    dto.data = this.excelRows.map(r => {
      const row = new TransferRequestBulkRowDto();
      row.StoreOriginCode = r.StoreOriginCode;
      row.StoreDestinyCode = r.StoreDestinyCode;
      row.Sector = r.Sector;
      row.StyleVariety = r.StyleVariety;
      row.SizeName = r.Size;
      row.Season = r.Season;
      row.Comment = r.Comment;
      row.Quantity = r.Quantity;
      return row;
    });

    this._bulkFacade.UploadBulk(dto).subscribe(
      response => {
        this.loading = false;
        this.isDisabledSaveTransfer = false;
        if (response.completed) {
          this.modal.hide();
          this.addAlert('<strong>' + this.strings.GetText(res.BulkUploadStartedNotice) + '</strong>', 'success', 'general');
        } else {
          this.addAlert('<strong>' + response.message + '</strong>', 'danger', 'excel');
          this.logIncident(String(response.message));
        }
      },
      err => {
        this.loading = false;
        this.isDisabledSaveTransfer = false;
        this.addAlert('<strong>' + String(err) + '</strong>', 'danger', 'excel');
        this.logIncident(String(err));
      }
    );
  }

  /** Abre el panel "Mis cargas" y carga la lista de jobs. */
  openBulkLogs() {
    // Abrir el modal primero (feedback inmediato); luego cargar.
    this.bulkLogsModal.show();
    this.loadBulkJobs();
    // Cuando el usuario cierra el modal, detener el auto-refresh.
    this.bulkLogsModal.onHidden.subscribe(() => this.stopBulkJobsPolling());
  }

  /**
   * Carga la lista de jobs. Si recibe un refresco automatico (silent=true) no muestra el
   * spinner global ni bloquea, para no parpadear la tabla mientras el usuario la observa.
   */
  loadBulkJobs(silent: boolean = false) {
    // Guard anti doble-clic en la carga manual; el refresco silencioso sí puede solaparse.
    if (!silent && this.bulkLoadingLogs) { return; }
    if (!silent) { this.bulkLoadingLogs = true; }
    this._bulkFacade.GetJobs().subscribe(
      response => {
        this.bulkLoadingLogs = false;
        this.bulkJobs = response.completed && response.data ? response.data : [];
        // Auto-refresh: si hay jobs activos, seguir sondeando; si no, detener.
        this.syncBulkJobsPolling();
      },
      err => {
        this.bulkLoadingLogs = false;
        if (!silent) {
          this.addAlert('<strong>' + String(err) + '</strong>', 'danger', 'general');
        }
      }
    );
  }

  /** ¿Hay algún job aún en cola o procesándose? */
  private get hasActiveBulkJobs(): boolean {
    return this.bulkJobs.some(j => j.status === 'Queued' || j.status === 'Processing');
  }

  /** Arranca/detiene el polling según haya o no jobs activos. */
  private syncBulkJobsPolling() {
    if (this.hasActiveBulkJobs) {
      this.startBulkJobsPolling();
    } else {
      this.stopBulkJobsPolling();
    }
  }

  private startBulkJobsPolling() {
    if (this._bulkJobsPolling) { return; } // ya activo
    this._bulkJobsPolling = setInterval(() => this.loadBulkJobs(true), this._bulkPollMs);
  }

  private stopBulkJobsPolling() {
    if (this._bulkJobsPolling) {
      clearInterval(this._bulkJobsPolling);
      this._bulkJobsPolling = undefined;
    }
  }

  /** Etiqueta legible y traducida del estado del job. */
  bulkStatusLabel(status: string): string {
    switch (status) {
      case 'Queued': return this.strings.GetText(res.BulkStatusQueued);
      case 'Processing': return this.strings.GetText(res.BulkStatusProcessing);
      case 'Done': return this.strings.GetText(res.BulkStatusDone);
      case 'CompletedWithErrors': return this.strings.GetText(res.BulkStatusCompletedWithErrors);
      case 'Failed': return this.strings.GetText(res.BulkStatusFailed);
      default: return status;
    }
  }

  /**
  /** Clase de color del badge segun el estado del job. */
  bulkStatusClass(status: string): string {
    switch (status) {
      case 'Queued': return 'badge-secondary';
      case 'Processing': return 'badge-info';
      case 'Done': return 'badge-success';
      case 'CompletedWithErrors': return 'badge-warning';
      case 'Failed': return 'badge-danger';
      default: return 'badge-light';
    }
  }

  /**
   * Descarga el Excel (.xlsx) de registros NO procesados del job indicado. Lo genera el SERVIDOR
   * (ClosedXML, con los codigos como texto para no truncar ceros a la izquierda ni caer en notacion
   * cientifica). El navegador NO arma el documento: recibe el blob (via HttpClient para que lleve el
   * token de sesion) y lo guarda. Es un espejo del layout (mismas columnas + Folio/Estado/Motivo).
   */
  downloadBulkFailed(guid: string) {
    if (this.bulkLoadingFailed) { return; }   // guard anti doble-clic (una descarga a la vez)
    if (!guid) { return; }

    this.bulkSelectedGuid = guid;
    this.bulkLoadingFailed = true;
    this._bulkFacade.DownloadNotProcessed(guid, this.language).subscribe(
      blob => {
        this.bulkLoadingFailed = false;
        if (!blob || blob.size === 0) {
          this.addAlert('<strong>' + this.strings.GetText(res.BulkNoFailedRecords) + '</strong>', 'warning', 'general');
          return;
        }
        FileSaver.saveAs(blob, 'TraspasosBulk_NoProcesados_' + guid.substring(0, 8) + '.xlsx');
      },
      err => {
        this.bulkLoadingFailed = false;
        this.addAlert('<strong>' + String(err) + '</strong>', 'danger', 'general');
        this.logIncident(String(err));
      }
    );
  }

  onChangeOrganization(selected: Organization[]) {
    this.selectedOrganizations = selected;
    this.getStores();
    this.getSectors();
  }

  private getNowUTC() {
    const now = new Date();
    return new Date(now.getTime() + (now.getTimezoneOffset() * 60000));
  }

  private getNowUTCLess6hr() {
    const now = new Date();
    return new Date(now.getTime() - (now.getTimezoneOffset() * 60000));
  }

  onChangeStartDateResumen(value: any) {
    this.txtStartDateResumen = this.subtractTimeFromDate(value, 6);
    this.startDateResumen = this.txtStartDateResumen;
  }

  onChangeEndDateResumen(value: any) {
    this.txtEndDateResumen = this.subtractTimeFromDate(value, 6);
    this.endDateResumen = this.txtEndDateResumen;
  }

  getTransferRequestByDates() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.ObtainingTransfersBetweenStores);
    this.strOrganizationSelected = this.selectedOrganizations.map(e => e.organizationId).join(',');
    if (new Date(this.txtStartDateResumen) > new Date(this.txtEndDateResumen)) {
      this.addAlert('<strong>' + this.strings.GetText(res.AlertTheStartDateCannotBeHigher) + '</strong>', 'danger', 'general');
    } else {
      this._transferRequestFacade.GetCollectionTransferRequestByDates(
        this.strOrganizationSelected
        , this.datepipe.transform(this.txtStartDateResumen, 'yyyyMMdd_00:00:00') + '.000'
        , this.datepipe.transform(this.txtEndDateResumen, 'yyyyMMdd_00:00:00') + '.000'
        , this.isSpanish).subscribe(
          response => {
            this.rows = response.data;
            this._filteredData = response.data;
            this.UpdateSelection();
            this.loading = false;
          }, err => {
            this.loading = false;
            this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertTransfersCouldNotBeObtained), 'danger', 'general');
            this.logIncident(String(err));
          }
        );
    }
  }

  getMessageErrorDataValidation(message: string, vOnlySizes: boolean = false, multiROw: boolean = false): string {
    if (!vOnlySizes) {
      message = message.split('ErrorValidatingStores:').join('');
      message = message.split('nErrorValidatingOnlySizes:').join('');
      message = this.consolidateErrorValues(message, [
        { code: 'ErrorSector:', label: this.strings.GetText(res.ErrorTransferSector) },
        { code: 'ErrorStoreOriginDestiny:', label: this.strings.GetText(res.ErrorTransferStoreOriginDestiny) },
        { code: 'ErrorStoreNotOnlyMigrated:', label: this.strings.GetText(res.ErrorTransferStoreNotOnlyMigrated) },
        { code: 'ErrorStoreOrganization:', label: this.strings.GetText(res.ErrorTransferStoreOrganization) },
        { code: 'nErrorOrganization:', label: this.strings.GetText(res.ErrorTransferOrganization) },
        { code: 'ErrorStyleOrganization:', label: this.strings.GetText(res.ErrorTransferStyleOrganization) },
        { code: 'ErrorStyleVariety:', label: this.strings.GetText(res.ErrorTransferStyleVariety) },
        { code: 'ErrorStyleSizeOrganization:', label: this.strings.GetText(res.ErrorTransferStyleSizeOrganization) },
        { code: 'ErrorStyleSize:', label: this.strings.GetText(res.ErrorTransferStyleSize) }
      ]);
    } else {
      message = message.split('ErrorValidatingOnlySizes:').join('');
      message = this.consolidateErrorValues(message, [
        { code: 'ErrorStyleOrganization:', label: this.strings.GetText(res.ErrorTransferStyleOrganization) },
        { code: 'ErrorStyleVariety:', label: this.strings.GetText(res.ErrorTransferStyleVariety) },
        { code: 'ErrorStyleSize:', label: this.strings.GetText(res.ErrorTransferStyleSize) },
        { code: 'ErrorStyleSizeOrganization:', label: this.strings.GetText(res.ErrorTransferStyleSizeOrganization) },
        { code: 'ErrorStyleSizeQuantity:', label: this.strings.GetText(res.ErrorTransferStyleQuantity) }
      ]);
    }
    if (multiROw) {
      message = message.replace('ErrorStyleSizeMultiRow:', this.strings.GetText(res.ErrorTransferStyleSizeMultiRow));
    }
    return message;
  }

  private consolidateErrorValues(message: string, errorTypes: { code: string; label: string }[]): string {
    let result = '';
    const allCodes = errorTypes.map(e => e.code);
    for (const errorType of errorTypes) {
      if (!message.includes(errorType.code)) { continue; }
      const values = new Set<string>();
      const parts = message.split(errorType.code);
      for (let i = 1; i < parts.length; i++) {
        let block = parts[i];
        for (const otherCode of allCodes) {
          const idx = block.indexOf(otherCode);
          if (idx >= 0) { block = block.substring(0, idx); }
        }
        block.split(/\n|<br>|,/).forEach(v => {
          const trimmed = v.replace(/<[^>]*>/g, '').trim();
          if (trimmed) { values.add(trimmed); }
        });
      }
      if (values.size > 0) {
        result += errorType.label + '<br>' + Array.from(values).join('<br>') + ' ';
      }
      let cleaned = parts[0];
      for (let i = 1; i < parts.length; i++) {
        let block = parts[i];
        let cutAt = block.length;
        for (const otherCode of allCodes) {
          const idx = block.indexOf(otherCode);
          if (idx >= 0 && idx < cutAt) { cutAt = idx; }
        }
        cleaned += block.substring(cutAt);
      }
      message = cleaned;
    }
    const leftover = message.replace(/\n|<br>/g, ' ').trim();
    return result + leftover;
  }

  resetFileInput() {
    this.fileNameModal = '';
    const input = document.getElementById('btn_upload_layout') as HTMLInputElement;
    if (input) {
      input.value = '';
    }
    const label = document.querySelector('.custom-file-label');
    if (label) {
      label.textContent = this.strings.GetText(this.lblSelectAFile);
    }
  }

  // === Deactivation Modal ===

  openDeactivateModal() {
    this.deactivateCandidates = this.rows.filter(r => r.taskId > 0);
    this.deactivateSelected = new Set();
    this.deactivateFilterSector = '-1';
    this.deactivateFilterWeek = '-1';
    this.deactivateFilterRef = '';
    this.deactivateProgress = null;
    this.deactivateResults = [];
    this._deactivateFailedIds = [];
    this.deactivateConfirmStep = false;
    this.applyDeactivateFilters();
    this.deactivateModal.show();
  }

  applyDeactivateFilters() {
    let data = this.deactivateCandidates;
    if (this.deactivateFilterSector !== '-1') {
      data = data.filter(r => r.catDetSectorId.toString() === this.deactivateFilterSector);
    }
    if (this.deactivateFilterWeek !== '-1') {
      data = data.filter(r => r.week.toString() === this.deactivateFilterWeek);
    }
    if (this.deactivateFilterRef.trim().length > 0) {
      const val = this.deactivateFilterRef.toLowerCase();
      data = data.filter(r => (r.reference || '').toLowerCase().includes(val) || r.code.toLowerCase().includes(val));
    }
    this.deactivateFiltered = data;
    // Keep only selections visible in current filter
    const visibleIds = new Set(data.map(r => r.taskId));
    this.deactivateSelected.forEach(id => {
      if (!visibleIds.has(id)) {
        this.deactivateSelected.delete(id);
      }
    });
    this.deactivateConfirmStep = false;
  }

  toggleDeactivateAll(event: any) {
    if (event.target.checked) {
      this.deactivateFiltered.forEach(r => this.deactivateSelected.add(r.taskId));
    } else {
      this.deactivateFiltered.forEach(r => this.deactivateSelected.delete(r.taskId));
    }
    this.deactivateConfirmStep = false;
  }

  toggleDeactivateItem(taskId: number) {
    if (this.deactivateSelected.has(taskId)) {
      this.deactivateSelected.delete(taskId);
    } else {
      this.deactivateSelected.add(taskId);
    }
    this.deactivateConfirmStep = false;
  }

  get allFilteredSelected(): boolean {
    return this.deactivateFiltered.length > 0 && this.deactivateFiltered.every(r => this.deactivateSelected.has(r.taskId));
  }

  get deactivateSuccessCount(): number {
    return this.deactivateResults.filter(r => r.success).length;
  }

  get deactivateHasLockReason(): boolean {
    return this.deactivateResults.some(r => r.reason === this.deactivationReasonLock || r.reason === this.deactivationReasonStopped);
  }

  requestDeactivate() {
    if (!this.deactivateConfirmStep) {
      this.deactivateConfirmStep = true;
      return;
    }
  }

  startHoldDeactivate() {
    if (!this.deactivateConfirmStep || this.deactivateSelected.size === 0 || this.deactivateProgress) { return; }
    this.deactivateHoldProgress = 0;
    const totalMs = 1500;
    const intervalMs = 30;
    const step = (intervalMs / totalMs) * 100;
    this._holdInterval = setInterval(() => {
      this.deactivateHoldProgress += step;
      if (this.deactivateHoldProgress >= 100) {
        this.cancelHoldDeactivate();
        this.confirmDeactivate();
      }
    }, intervalMs);
  }

  cancelHoldDeactivate() {
    if (this._holdInterval) {
      clearInterval(this._holdInterval);
      this._holdInterval = null;
    }
    this.deactivateHoldProgress = 0;
  }

  async confirmDeactivate() {
    const taskIds = Array.from(this.deactivateSelected);
    if (taskIds.length === 0) { return; }

    this.deactivateResults = [];
    this._deactivateFailedIds = [];
    this.deactivateProgress = { current: 0, total: taskIds.length };
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.DeactivateRequests);

    for (const taskId of taskIds) {
      const result = await this.postDeactivateTask(taskId);
      this.deactivateProgress = { ...this.deactivateProgress, current: this.deactivateProgress.current + 1 };

      this.deactivateResults.push(result);

      if (!result.success) {
        this._deactivateFailedIds.push(taskId);

        if (result.reason === DeactivationReason.WithinLockWindow) {
          // Detener: ya entramos en ventana de bloqueo
          const remaining = taskIds.slice(this.deactivateProgress.current);
          remaining.forEach(id => {
            this._deactivateFailedIds.push(id);
            const row = this.deactivateCandidates.find(r => r.taskId === id);
            this.deactivateResults.push({ code: row ? row.code : String(id), success: false, reason: DeactivationReason.StoppedByLock, scheduleDate: result.scheduleDate });
          });
          break;
        }
      }
    }

    this.deactivateProgress = null;
    this.loading = false;
    this.deactivateSelected = new Set(this._deactivateFailedIds);

    if (this._deactivateFailedIds.length === 0) {
      this.deactivateModal.hide();
      this.addAlert('<strong>' + this.strings.GetText(res.DeactivateSuccess) + '</strong>', 'success', 'general');
      this.getTransferRequestByDates();
    }
  }

  retryDeactivate() {
    this.deactivateSelected = new Set(this._deactivateFailedIds);
    this.deactivateResults = [];
    this._deactivateFailedIds = [];
    this.deactivateConfirmStep = false;
  }

  private postDeactivateTask(taskId: number): Promise<{ code: string; success: boolean; reason: string; scheduleDate?: string }> {
    return new Promise(resolve => {
      const row = this.deactivateCandidates.find(r => r.taskId === taskId);
      const code = row ? row.code : String(taskId);
      this._transferRequestFacade.PostDeactivateTask(taskId).subscribe(
        response => {
          if (response.completed && response.data) {
            resolve({ code, success: response.data.success, reason: response.data.reason || '', scheduleDate: response.data.scheduleDate });
          } else {
            resolve({ code, success: false, reason: response.message || 'ERROR' });
          }
        },
        error => resolve({ code, success: false, reason: error?.status ? `HTTP ${error.status}` : 'NETWORK_ERROR' })
      );
    });
  }

  getDeactivateResult(code: string): { success: boolean; reason: string; scheduleDate?: string } | null {
    return this.deactivateResults.find(r => r.code === code) || null;
  }

  get deactivateLockScheduleDate(): string | null {
    const r = this.deactivateResults.find(x => x.reason === DeactivationReason.WithinLockWindow && x.scheduleDate);
    return r ? r.scheduleDate ?? null : null;
  }

  subtractTimeFromDate(objDate: { getTime: () => any; }, intHours: number) {
    const numberOfMlSeconds = objDate.getTime();
    const addMlSeconds = intHours * 60 * 60000;
    return new Date(numberOfMlSeconds - addMlSeconds);
  }
}

